module.exports = __webpack_public_path__ + "static/media/thank.dffe9b09.jpg";